export default "__VITE_ASSET__Bwb7rQR8__"